import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from 'constants/constants'
import { query } from '../graphql'

export const useUserQuery = ({ username }) => {
  return useQuery({
    queryKey: QUERY_KEYS.userByUsername(username),
    queryFn: () => {
      return query({ query: 'getUser', variables: { id: username } })
    },
    enabled: !!username
  })
}
